import { Button } from "@/components/ui/button";
import { ArrowUpRight } from "lucide-react";

const ELEVEN41_IMG = "https://customer-assets.emergentagent.com/job_eleven-41-preview/artifacts/h7w0m16k_Block_C.jpg";

export default function FeaturedDevelopment() {
  return (
    <section
      id="eleven41"
      data-testid="featured-development-section"
      className="bg-[#F8F9FA] py-24 lg:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Image */}
          <div className="relative overflow-hidden rounded-md" data-testid="eleven41-image-container">
            <img
              src={ELEVEN41_IMG}
              alt="Eleven 41 Business Center"
              className="w-full h-auto object-cover aspect-[4/3]"
              data-testid="eleven41-image"
            />
          </div>

          {/* Text */}
          <div>
            <span
              className="text-xs font-semibold tracking-[0.2em] uppercase text-[#D49A38] block"
              style={{ fontFamily: "Manrope, sans-serif" }}
              data-testid="eleven41-overline"
            >
              Featured Development
            </span>
            <div className="w-12 h-[2px] bg-[#D49A38] mt-4 mb-6" />

            <h2
              className="mt-0 text-3xl sm:text-4xl lg:text-5xl font-bold text-[#182649] tracking-tight leading-[1.1] uppercase"
              style={{ fontFamily: "Outfit, sans-serif" }}
              data-testid="eleven41-headline"
            >
              Eleven 41 <span className="text-[#D49A38]">Business</span> Center
            </h2>

            <p
              className="mt-6 text-base md:text-lg text-[#4A5568] leading-relaxed"
              style={{ fontFamily: "Manrope, sans-serif" }}
              data-testid="eleven41-text"
            >
              A modern logistics and business facility developed by Tailwind, designed for companies looking to establish or expand operations in Jamaica.
            </p>

            <Button
              asChild
              className="mt-8 bg-[#D49A38] text-white hover:bg-[#c08a2e] rounded-full px-8 py-6 text-base font-semibold transition-all duration-300 shadow-lg"
              data-testid="eleven41-cta-button"
            >
              <a href="https://1141bc.com" target="_blank" rel="noopener noreferrer">
                View available units
                <ArrowUpRight className="ml-2 h-4 w-4" />
              </a>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
